import { render, staticRenderFns } from "./CourseFolderItem.vue?vue&type=template&id=1da311e6&"
import script from "./CourseFolderItem.vue?vue&type=script&lang=js&"
export * from "./CourseFolderItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseFolderItem.vue?vue&type=style&index=0&id=1da311e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports